import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const crearOEditarArea = async (area) => {
    try {
        if (area.get('id')) {
            const resp = await axios.post(
                `${API_URL}/areas/editar/${area.get('id')}`,
                area,
                { headers: getHeaders() }
            );

            return resp.data;
        }

        const resp = await axios.post(
            `${API_URL}/areas`,
            area,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarArea = async (id_area) => {
    try {
        const resp = await axios.delete(
            `${API_URL}/areas/${id_area}`,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const activarArea = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/areas/activar/${data.id}`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};